<template>
  <div class="context"
       v-loading="loading"
       element-loading-text="拼命加载中">
    <div class="imageStyle" v-if="fileList.length!==0">
      <img id="img" :style="{transform:'scale('+multiples+')'}" :src=fileList[currentSub].url @mousedown.prevent="dropImage" @mouseup.prevent="loosen" @mousewheel.prevent='gunlun'/>
      <el-button icon="el-icon-arrow-left" circle class="iconArrow leftButton" @click="prevPage"></el-button>
      <el-button icon="el-icon-arrow-right" circle class="iconArrow rightButton" @click="nextPage"></el-button>
    </div>
    <div class="imageInfo" v-if="fileList.length!==0">
      <el-descriptions class="margin-top" title="图纸信息" :column="2" size="medium" border>
        <el-descriptions-item>
          <template #label>
            <i class="el-icon-user"></i>文件名
          </template>
          {{fileList[currentSub].fileName}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <i class="el-icon-mobile-phone"></i>当前版本
          </template>
          v{{fileList[currentSub].versions}}.0
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <i class="el-icon-location-outline"></i>大小
          </template>
          {{ fileList[currentSub].size }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <i class="el-icon-tickets"></i>当前状态
          </template>
          {{fileList[currentSub].statusName}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <i class="el-icon-office-building"></i>创建人
          </template>
          {{ fileList[currentSub].createUserName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <i class="el-icon-office-building"></i>创建时间
          </template>
          {{ fileList[currentSub].createTime }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <i class="el-icon-office-building"></i>更新人
          </template>
          {{ fileList[currentSub].updateUserName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <i class="el-icon-office-building"></i>更新时间
          </template>
          {{ fileList[currentSub].updateTime }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <i class="el-icon-office-building"></i>备注
          </template>
          {{ fileList[currentSub].remark }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
</template>

<script>
export default {
  name: "LookPdf",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      fileList: [],
      currentSub: 0,
      multiples: 1,
      odiv: null,
      loading: false,
    }
  },
  methods:{
    prevPage(){
      if (this.currentSub-1 <0){
        this.$message.error("当前已经是第一页了，不能再上一页了。")
      }else {
        this.currentSub--
      }
    },

    nextPage(){
      if (this.currentSub+1 >= this.fileList.length){
        this.$message.error("当前已经是最后一页了，不能再下一页了。")
      }else {
        this.currentSub++
      }
    },
    gunlun(e) {
      let direction = e.deltaY > 0 ? 'down' : 'up'
      if (direction === 'up') {
        if (this.multiples >= 10) {
          return;
        }
        this.multiples += 0.25;
        // 滑轮向上滚动
      } else {
        if (this.multiples <= 0.5) {
          return;
        }
        this.multiples -= 0.25;
        // 滑轮向下滚动
      }
    },
    dropImage(e) {
      if (e === null) {
        return
      }
      this.odiv = e.target;        //获取目标元素
      //算出鼠标相对元素的位置
      let disX = e.clientX - this.odiv.offsetLeft;
      let disY = e.clientY - this.odiv.offsetTop;
      document.onmousemove = (e) => {       //鼠标按下并移动的事件
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        //绑定元素位置到positionX和positionY上面
        this.positionX = top;
        this.positionY = left;

        //移动当前元素
        this.odiv.style.left = left + 'px';
        this.odiv.style.top = top + 'px';
      }
    },
    loosen(){
      document.onmousemove = null;
      document.onmouseup = null;
    }
  },
  async created() {
    this.loading = true
    let {data: res} = await this.$axios.post('bus/fileStorage/getFileList', this.parentData);
    this.loading = false
    if (res.code !== 0){
      this.$message.error('获取文件失败：' + res.message)
      return;
    }
    this.fileList = res.data
  }
}
</script>

<style scoped>
img {
  height: 100%;
  width: auto;
  position: relative;
}
.iconArrow{
  width: 60px;
  height: 55px;
  font-size: 30px;
}
.leftButton{
  position: absolute;
  top: 45%;
  left: 2%;
  margin: auto;
}
.rightButton{
  position: absolute;
  top: 45%;
  right: 37%;
  margin: auto;
}
.imageInfo{
  width: 35%;
  height: 100%;
  background-color: #fffef9
}
.imageStyle{
  width: 65%;
  height: 99%;
  overflow:hidden
}
.context{
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row
}
</style>
